<template>
  <page-template :is-loading="isLoading" :data-exists="dnsRecords !== null">
    <template #pageHeadline>
      {{ $t('dnsRecords.pageHeadline') }}
    </template>
    <template #pageContent>
      <rbz-table
        :columns="columns"
        :table-data="dnsRecords"
        :sticky-header="true"
        :show-download-button="false"
        :show-new-button="false"
        :show-filter-row="true"
        data-qa="dns-table"
      >
      </rbz-table>
    </template>
  </page-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RbzTable from 'ui-component-library/rbz/components/RbzTable.vue';
import { DnsRecord } from '@/types';
import RequestsUtils from '@/helpers/RequestsUtils';
import PageTemplate from '@/views/PageTemplate.vue';
import { RbzTableColumnOptions } from 'ui-component-library/rbz/types';
import { useUserStore } from '@/store/UserStore';
import { mapStores } from 'pinia';

export default defineComponent({
  name: 'DNSRecords',
  components: {
    PageTemplate,
    RbzTable,
  },
  computed: {
    ...mapStores(useUserStore),
    userPlanet(): string {
      return this.userStore.getUserPlanet();
    },
  },

  data() {
    return {
      columns: [
        {
          id: 'name',
          title: this.$t('dnsRecords.name'),
          fieldNames: ['name'],
          isSortable: true,
          isSearchable: true,
          classes: 'width-300px',
          cellContentClasses: 'word-break-all',
          autoFocus: true,
        },
        {
          id: 'type',
          title: this.$t('dnsRecords.type'),
          fieldNames: ['type'],
          isSortable: true,
          isSearchable: true,
          classes: 'width-120px',
          cellContentClasses: 'word-break-all',
        },
        {
          id: 'ttl',
          title: this.$t('dnsRecords.ttl'),
          fieldNames: ['ttl'],
          isSortable: true,
          isSearchable: true,
          isNumber: true,
          classes: 'width-120px',
        },
        {
          id: 'value',
          title: this.$t('dnsRecords.value'),
          fieldNames: ['resource_records'],
          displayFunction: (item: DnsRecord) => {
            return item.resource_records?.join('\n');
          },
          isSortable: true,
          isSearchable: true,
          cellContentClasses: 'multi-line white-space-pre-line word-break-all',
        },
      ] as RbzTableColumnOptions[],
      dnsRecords: null as DnsRecord[],
      isLoading: true,
    };
  },
  methods: {
    async loadDNS() {
      this.isLoading = true;
      const url = 'tools/dns-information';
      const methodName = 'GET';
      const response = await RequestsUtils.sendRequest({ host: this.userPlanet, methodName, url });
      this.dnsRecords = response?.data?.['dns_records'] || [];
      this.isLoading = false;
    },
  },
  mounted() {
    this.loadDNS();
  },
});
</script>

<style scoped lang="scss">
:deep(.word-break-all) {
  word-break: break-all;
}

:deep(.rbz-table .multi-line) {
  -webkit-line-clamp: 10;
}
</style>
